import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TwoFactorPromptComponent } from '../../modules/shared/two-factor-prompt/two-factor-prompt.component';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorPromptService {
  private dialogRef: MatDialogRef<TwoFactorPromptComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  /**
   * Opens a 2FA code prompt dialog and returns an Observable that emits
   * the entered code (string) or null if the user cancelled.
   */
  prompt(config?: { title?: string; message?: string }): Observable<string | null> {
    // Prevent stacking multiple prompts
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }

    this.dialogRef = this.dialog.open(TwoFactorPromptComponent, {
      width: '420px',
      disableClose: true,
      autoFocus: false,
      data: {
        title: config?.title || '2FA Verification Required',
        message: config?.message || 'Enter your 6-digit authenticator code to continue.',
      },
    });

    return this.dialogRef.afterClosed();
  }
}
